import { ChangeEvent } from "react";
import { InputStyle, MergeWithOverwrite, ValidationErrorStyle } from "src/common";
import { InputLabel } from "src/components";

export type InputNumberProps = MergeWithOverwrite<React.InputHTMLAttributes<HTMLInputElement>, {
  label?: string;
  value?: string;
  min?: number;
  max?: number;
  error?: string;
  onChange?: (value: string) => void;
}
>;

export const InputNumber: React.FC<InputNumberProps> = ({
  label,
  error = '',
  value = '',
  min = 0,
  max = Infinity,
  onChange,
  ...props
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      const newValue = e.target.value;
      if (Number(newValue) >= min && Number(newValue) <= max) onChange(newValue.toString());
      // onChange(newValue)
    }
  }

  return (
    <div>
      {label ? <InputLabel htmlFor={props.id} disabled={props.disabled}>{label}</InputLabel> : null}
      <InputStyle
        autoComplete="off"
        {...props}
        type='number'
        id={props.id}
        onChange={handleChange}
        hasError={!!error}
        value={value}
      />
      {error ? <ValidationErrorStyle>{error}</ValidationErrorStyle> : null}
    </div>
  );
};
